import qs from 'qs';
import { network } from 'services/network';

export const deleteComponent = ({ componentId }) => {
    const querystring = qs.stringify({ componentId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/reporting/deleteComponent${querystring}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
